/**
 * Reports only slow interaction candidates to GA4 for INP attribution.
 * No form values, product names, visitor IDs, or DOM text are collected.
 */
(() => {
  if (!('PerformanceObserver' in window) || !('PerformanceEventTiming' in window)) return;

  let worstInteraction;
  let reported = false;

  const getTargetArea = (target) => {
    if (!(target instanceof Element)) return 'unknown';
    if (target.closest('product-form-component, sticky-add-to-cart')) return 'product_form';
    if (target.closest('header-component, #header-group')) return 'header';
    if (target.closest('.jdgm-widget, .jdgm-preview-badge')) return 'reviews';
    if (target.closest('slideshow-component, layered-slideshow-component')) return 'slideshow';
    if (target.closest('form')) return 'form';
    return target.tagName.toLowerCase();
  };

  const observeInteractions = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (!entry.interactionId || !entry.duration) continue;

      if (!worstInteraction || entry.duration > worstInteraction.duration) {
        worstInteraction = {
          duration: entry.duration,
          type: entry.name,
          targetArea: getTargetArea(entry.target),
        };
      }
    }
  });

  try {
    observeInteractions.observe({ type: 'event', buffered: true, durationThreshold: 40 });
  } catch {
    return;
  }

  const reportWorstInteraction = () => {
    if (reported || !worstInteraction || typeof window.gtag !== 'function') return;
    reported = true;

    window.gtag('event', 'inp_attribution', {
      value: Math.round(worstInteraction.duration),
      interaction_type: worstInteraction.type,
      interaction_area: worstInteraction.targetArea,
      page_type: document.querySelector('#MainContent')?.dataset.template || 'unknown',
      transport_type: 'beacon',
      non_interaction: true,
    });
  };

  window.addEventListener('pagehide', reportWorstInteraction, { once: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') reportWorstInteraction();
  });
})();
